import * as React from 'react';
import PropTypes from 'prop-types';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';

const products = [
  {
    name: 'MCB DYNAMICS',
    desc: 'Lifetime subscription',
    price: 'A$293.00',
  },
  {
    name: 'Tax',
    desc: '',
    price: 'A$0.00',
  },
];

function Info({ totalPrice }) {
  return (
    <React.Fragment >
      <Typography sx={{fontFamily: 'math'}}>
        <h2>MCB Dynamics</h2>
      </Typography>
      <Typography variant="subtitle2" sx={{ color: 'text.secondary', fontFamily: 'math' }}>
        Total:
      </Typography>
      <Typography variant="h6" gutterBottom sx={{fontFamily: 'math'}}>
        {totalPrice}
      </Typography>
      <List disablePadding>
        {products.map((product) => (
          <ListItem key={product.name} sx={{ py: 1, px: 0, fontFamily: 'math' }}>
            <ListItemText
              sx={{ mr: 2, fontFamily: 'math'}}
              primary={product.name}
              secondary={product.desc}
            />
            <Typography variant="body1" sx={{ fontWeight: 'medium', fontFamily: 'math' }}>
              {product.price}
            </Typography>
          </ListItem>
        ))}
      </List>
    </React.Fragment>
  );
}

Info.propTypes = {
  totalPrice: PropTypes.string.isRequired,
};

export default Info;
